import qs from "query-string";

import { createApiV2 } from "./common";

export const getCustomerLists = (params) => (token) =>
  createApiV2("GET", `customers/?${qs.stringify(params)}`)(token);

export const getUsers = (params) => (token) =>
  createApiV2("GET", `users/?${qs.stringify(params)}`)(token);

export const getCustomer =
  (customerUid, params = {}) =>
  (token) => {
    const queryParams = qs.stringify(params);
    return createApiV2("GET", `customers/${customerUid}/?${queryParams}`)(token);
  };

export const getCustomerContacts =
  ({ customerUid, contactSearch, params = {} }) =>
  (token) => {
    const queryParams = qs.stringify({ search: contactSearch, ...params });
    return createApiV2("GET", `customers/${customerUid}/contacts/?${queryParams}`)(token);
  };

export const postCustomerContacts = (customerUid, data) => (token) =>
  createApiV2("POST", `customers/${customerUid}/contacts/`)(token, data);

export const getCustomerAddresses =
  ({ customerUid, addressSearch, params = {} }) =>
  (token) => {
    const queryParams = qs.stringify({ search: addressSearch, ...params });
    return createApiV2("GET", `customers/${customerUid}/addresses?${queryParams}`)(token);
  };

export const postCustomer = (data) => (token) => createApiV2("POST", "customers/")(token, data);

export const changeCustomerContacts =
  ({ customerUid, data }) =>
  (token) =>
    createApiV2("PUT", `customers/${customerUid}/`)(token, data);

export const putCustomerContacts =
  ({ uid, customerUid, data }) =>
  (token) =>
    createApiV2("PUT", `customers/${customerUid}/contacts/${uid}/`)(token, data);

export const changeCustomerData =
  ({ customerUid, data }) =>
  (token) =>
    createApiV2("PUT", `customers/${customerUid}/`)(token, data);

export const getUserV2 = () => () => createApiV2("GET", "customer/userdata/")();

export const putCustomerAddress =
  ({ uid, customerUid, data }) =>
  (token) =>
    createApiV2("PUT", `customers/${customerUid}/addresses/${uid}/`)(token, data);

export const postCustomerAddress = (customerUid, data) => (token) =>
  createApiV2("POST", `customers/${customerUid}/addresses/`)(token, data);
